/// <reference path="../api/types/api.d.ts" />
import { useMutation, useQuery } from '@tanstack/react-query';

import { HttpMethods } from '../api/httpMethods';

interface CodeDto {
  code: string;
}

export interface CreateUserRequestDto {
  username?: string;
  password?: string;
  avatar?: string;
  email?: string;
  description?: string;
  externalId: string;
  role: CodeDto;
  displayLanguageCode?: string;
  storyLanguageCode?: string;
  source?: string;
}

export const useCreateUser = (http: HttpMethods) => {
  return useMutation({
    mutationFn: (req: CreateUserRequestDto) => http.post<{ id: string }>('/users', req, { useToken: false }),
  });
};

interface CustomTokenResponseDto {
  token: string;
}

export const getCustomToken = (http: HttpMethods) => {
  return http.get<CustomTokenResponseDto>('/auth/token');
};

export const useGetCustomToken = (http: HttpMethods) => {
  return useQuery({ queryKey: ['custom-token'], queryFn: () => getCustomToken(http) });
};
